import { render, staticRenderFns } from "./MyPaymentMethods.vue?vue&type=template&id=23c61794"
import script from "./MyPaymentMethods.vue?vue&type=script&lang=js"
export * from "./MyPaymentMethods.vue?vue&type=script&lang=js"
import style0 from "./MyPaymentMethods.vue?vue&type=style&index=0&id=23c61794&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports